// extracted by mini-css-extract-plugin
module.exports = {"content":"ZGKOfD","description":"_19gmUD","shine-lines":"vy6_Yt"};